import http from '../../../http-common';

export function requestLoadMovimientosBancarios(idBanco, idCuenta) {
    return http.get('/movimientos-bancarios', {
        params: { idBanco, idCuenta },
    });
}

export function requestSaveMovimientoBancario(movimientoBancario) {
    return http.post('/movimientos-bancarios', movimientoBancario);
}
